// Reducer CONSTANTS
export const FETCHED_PAGE = 'FETCHED_PAGE';
export const FETCHED_GIFT = 'FETCHED_GIFT';
export const FETCHED_PAYMENT_LINK = 'FETCHED_PAYMENT_LINK';

// Module names
export const MODULE_PAGE = 'PAGE';
export const MODULE_GIFT = 'GIFT';
export const MODULE_PAYMENT_LINK = 'PAYMENT_LINK';

// Goal Type
export const GOAL_TYPE_DONORS = 'donor';
export const GOAL_TYPE_AMOUNT = 'amount';

// Payment Steps
export const CURRENCY_SELECTOR = 'currency_selector';
export const FUND_SELECTOR = 'fund_selector';
export const STEP_CART = 'cart';
export const AMOUNT_SLABS = 'amount_slabs';
export const PREPAYMENT_FORM = 'pre_payment_form';
export const THANK_YOU_PAGE = 'thank_you_page';
export const SHARE_PAGE = 'share_page';
export const FAILED_PAYMENT = 'failed_payment';

// Page TYPES
export const PAGE_TYPE_CROWDFUNDING = 'crowdfunding';
export const PAGE_TYPE_CHECKOUT = 'checkout';
export const PAGE_TYPE_COMPETITIVE_FUNDRAISING = 'competitive_fundraising';

export const CAMPAIGN_TYPE = {
  MATCHING_GIFTS: 'type_matching_gifts',
  CUSTOM_CHALLENGE: 'type_custom_challenge',
  PARTICIPATION_CHALLENGE: 'type_participation_challenge',
  FUND_SPECIFIC_CAUSE: 'type_fund_specific_cause',
};

// Influence block text
export const InfluenceBlockText = {
  title: 'influencer-invite-title',
  description: 'influencer-invite-description',
};
// mark your calendar
export const CalendarBlockText = {
  title: 'add-to-calendar-title',
  description: 'add-to-calendar-description',
};

// Payment modal conditions
export const PAYMENT_MODAL_MUST_BE_MASKCLOSABLE = [FUND_SELECTOR, AMOUNT_SLABS, STEP_CART];

// Almasights touchpoints
export const TOUCHPOINTS = {
  VIEWED_GIVING_PAGE: 'giving-viewed-a-giving-page',
};

// Leader board gift visibility
export const GIFT_VISIBILITY_TRIBUTE = 'type_gift_visibility_show_tributes';
export const TYPE_GIFT_VISIBILITY_SHOW_GIFT_WITH_AMOUNT = 'type_gift_visibility_show_gift_with_amount';
export const TYPE_GIFT_VISIBILITY_SHOW_GIFT_WITHOUT_AMOUNT = 'type_gift_visibility_show_gift_without_amount';

export const DESCRIPTION_SECTION = 'description_section';
export const CHALLENGE_SECTION = 'challenge_section';
export const CAMPAIGN_HUB_SECTION = 'campaign_hub_section';
export const TRIBUTE_SECTION = 'tribute_section';
export const LEADERBOARD_SECTION = 'leaderboard_section';
export const HEATMAP_SECTION = 'heatmap_section';
export const GIFT_TICKER_SECTION = 'gift_ticker_section';
export const CUSTOM_SECTION = 'custom_section';
export const EXPLORE_MORE_SECTION = 'explore_more_section';

// Heat Map Types
export const HEATMAP_TYPE_USA = 'usa';
export const HEATMAP_TYPE_WORLD = 'world';

export const PAYMENT_INTERVAL_MAPPING = {
  ONE_TIME: null,
  MONTHLY: 'month',
  YEARLY: 'year',
};

export const INTERVAL_NAME_MAPPING = {
  null: '',
  month: 'monthly',
  year: 'yearly',
};

export const PAYMENT_GIFT_TYPE_MAPPING = {
  give_now: 'give_now',
  pledge: 'pledge',
};

// {isComplete: {isDarkMode: {iconBackgroundColor, iconColor}}}
export const METRIC_CARD_COLOR_CONFIG = {
  true: {
    true: {
      iconBackgroundColor: '#36B37E',
      iconColor: '#FFFFFF',
    },
    false: {
      iconBackgroundColor: '#C5EBDB',
      iconColor: '#0D492F',
    },
  },
  false: {
    true: {
      iconBackgroundColor: '#FFFFFF3D',
      iconColor: '#FFFFFF',
    },
    false: {
      iconBackgroundColor: '#F0F0F0',
      iconColor: '#1F1F1F',
    },
  },
};

export const PAYMENT_INTERVAL_NAME_MAPPING = {
  [PAYMENT_INTERVAL_MAPPING.ONE_TIME]: 'one-time-donation-tab-label',
  [PAYMENT_INTERVAL_MAPPING.MONTHLY]: 'monthly-recurring-donation-tab-label',
  [PAYMENT_INTERVAL_MAPPING.YEARLY]: 'yearly-recurring-donation-tab-label',
};

export const PAYMENT_TYPE_NAME_MAPPING = {
  [PAYMENT_GIFT_TYPE_MAPPING.give_now]: 'Give now',
  [PAYMENT_GIFT_TYPE_MAPPING.pledge]: 'Give later (Pledge)',
};

export const TYPE_OTHER_FUND = 'other_fund';

export const NEW_COMPETITIVE_LAYOUT_MESSAGE_TEXT = [
  'Classic layout restored for all pages',
  'Updated layout applied across all pages',
];

export const MAP_TYPE = {
  USA: 'usa',
  WORLD: 'world',
};

export const ONE_TIME = null;
export const MONTHLY = 'month';
export const ONE_TIME_PLEDGE = 'one-time-pledge';
export const MONTHLY_PLEDGE = 'monthly-pledge';
